module.exports = __webpack_public_path__ + "static/media/esposito.ecf2977f.jpg";